import { z } from 'zod'
import { CompanyField, CustomerField, type RequiredFieldsToRegisterERPSettings } from '../../models/CustomerERPSettings'

export const RequiredFieldsToRegisterERPSettingsDTO = z.object({
  company: z.array(z.nativeEnum(CompanyField)).nullish(),
  customer: z.array(z.nativeEnum(CustomerField)).nullish()
})

export type RequiredFieldsToRegisterERPSettingsDTO = z.infer<typeof RequiredFieldsToRegisterERPSettingsDTO>

export function mapRequiredFieldsToRegisterERPSettingsToDTO (model: RequiredFieldsToRegisterERPSettings): RequiredFieldsToRegisterERPSettingsDTO {
  return {
    company: model.company ?? undefined,
    customer: model.customer ?? undefined
  }
}

export function mapDTOToRequiredFieldsToRegisterERPSettings (dto: RequiredFieldsToRegisterERPSettingsDTO): RequiredFieldsToRegisterERPSettings {
  return {
    company: dto?.company ?? [],
    customer: dto?.customer ?? []
  }
}
